import Box from "@material-ui/core/Box";
import InboxIcon from "@material-ui/icons/Inbox";
import Typography from "@material-ui/core/Typography";
import { useEmptyStateStyles } from "./styles";

type EmptyStateProps = {
  loading?: boolean;
  loadingText?: string;
  message?: string;
};

export default function EmptyState({
  loading = false,
  loadingText = "Carregando...",
  message = "Nenhum dado encontrado.",
}: EmptyStateProps) {
  const { classes } = useEmptyStateStyles();
  return (
    <Box className={classes.root}>
      <InboxIcon className={classes.icon} />
      <Typography variant="subtitle1">
        {loading ? loadingText : message}
      </Typography>
    </Box>
  );
}
